import { render } from "./ColorPicker.vue?vue&type=template&id=772c35b7"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=772c35b7&lang=css"
script.render = render

export default script